export default {
    signin: "登录",
    signup: "注册",
    time_limited: "限时",
    time_limited_618: "限时买1得1",
    lable_recommended: "推荐",
    label_enterprise: "企业版",
    menu: {
        item_1: "AI翻译模型",
        item_2: "翻译智能体",
        item_3: "AI工具箱",
        item_4: "服务方案",
        item_5: "LanguageX社区",
        item_6: "一封信",
    },
    index: {
        banner_1_title: "为热爱语言的人而生",
        banner_1_btn: "立即体验",
        banner_1_btn_2: "加入等待列表",
        banner_2_title: "LanguageX斩获2022/2023WMT国际机器翻译大赛",
        banner_2_btn: "查看详情",

        model_1_title: "为专业语言服务而生的AI翻译平台",
        model_1_desc: "AI翻译大模型、翻译项目管理、语言专家协作的最佳实践",
        model_1_item_1_title: "AI翻译模型优选",
        model_1_item_1_desc: "找到全球范围最专业的翻译模型，并精确控制术语，整合至人机协作流程",
        model_1_item_2_title: "大模型翻译智能体",
        model_1_item_2_desc: "由术语工程师、译员、QA质检员、母语审校、项目经理组成的智能体本地化“团队”",

        model_2_title: "AI辅助翻译",
        model_2_desc: "你可以专注自己热爱的语言，无需关注复杂的翻译技术",
        model_2_item_1_title: "AI译后编辑",
        model_2_item_1_desc: "在所见即所得的编辑器修改译文，AI提供专家级辅助，获得精确译文",
        model_2_item_2_title: "翻译项目管理",
        model_2_item_2_desc: "多模型、多语言、多流程——多人协作如同一人，复杂项目管理从未如此简单",

        model_3_title: "AI工具箱",
        model_3_desc: "极致口碑的AI翻译工具系列",
        model_3_comesoon: "Coming Soon",
        model_3_item_1_title: "AI 润色",
        model_3_item_1_desc: "基于生成式 AI，你的随身母语润色专家",
        model_3_item_2_title: "语料对齐",
        model_3_item_2_desc: "业内领先的对齐算法，全新拖拽式对齐体验，AI让语料对齐更简单",
        model_3_item_3_title: "机翻检测",
        model_3_item_3_desc: "智能标记机翻痕迹，有效识别译文质量风险",
        model_3_item_4_title: "术语提取",
        model_3_item_4_desc: "智能提取批量文件术语，快速修改即可制作术语库",
        model_3_item_5_title: "QA检查",
        model_3_item_5_desc: "不止传统规则QA，更有基于语义理解的智能检查",
        model_3_item_6_title: "AI译配",
        model_3_item_6_desc: "一键翻译和配音，瞬间切换语言的AI魔法",
        model_3_item_7_title: "AI翻译评分",
        model_3_item_7_desc: "机翻译文智能评分，AI为你推荐参考翻译模型",

        model_4_title: "服务方案",
        model_4_tab_1: "会员",
        model_4_tab_2: "字符包",
        model_4_desc_1: "文档翻译、文本翻译、AI工具箱均按照原文字符数消耗流量。会员服务：购买日起一个月/半年/一年内有效，会员字符每月重置，不结转。字符包自购买日起一年内可用（",
        model_4_desc_link: "查看流量字符说明",
        model_4_desc_2: "）。活动解释权归LanguageX所有。",
        model_4_desc_3: "查看",
        model_4_desc_link_1: "查看详细权益对比",
        //feature_1
        model_4_item_1_title: "FREE",
        model_4_item_1_feature_1: "12款通用模型",
        model_4_item_1_feature_2: "6款个性模型",
        model_4_item_1_feature_3: "3款AI工具",
        model_4_item_1_feature_3_desc: "AI润色、AI评分、AI译配",
        // model_4_item_1_feature_4: "AI 润色",
        model_4_item_1_feature_5: "每月1万免费字符",
        model_4_item_1_feature_6: "文件最大5MB",
        model_4_item_1_feature_7: "AI译配免费试用1次",
        model_4_item_1_feature_8: "大模型文本翻译",
        model_4_item_1_btn: "免费使用",
        //feature_2
        model_4_item_2_title: "PRO",
        model_4_item_2_feature_1: "所有Free版功能",
        model_4_item_2_feature_1_desc: "ChatGPT/Gemini/ DeepSeek等大模型文档翻译",
        model_4_item_2_feature_2: "9款垂直领域模型",
        model_4_item_2_feature_3: "术语定制",
        model_4_item_2_feature_4: "创建自己的个性模型",
        model_4_item_2_feature_5: "5款AI工具",
        model_4_item_2_feature_5_desc: "AI润色、翻译评分、术语提取、AI译配、机翻检测",
        model_4_item_2_feature_6: "每月50万免费字符",
        model_4_item_2_feature_7: "文件最大30MB",
        model_4_item_2_feature_8: "PDF格式支持",
        model_4_item_2_price_1: "￥59",
        model_4_item_2_price_1_crossed: "￥99",
        model_4_item_2_price_1_expires: "月",
        model_4_item_2_price_2: "￥329",
        model_4_item_2_price_2_crossed: "￥549",
        model_4_item_2_price_2_expires: "半年",
        model_4_item_2_price_3: "￥599",
        model_4_item_2_price_3_crossed: "￥999",
        model_4_item_2_price_3_expires: "年",
        model_4_item_2_btn: "7天免费体验",
        //feature_3
        model_4_item_3_title: "团队版/企业版",
        model_4_item_3_feature_1: "所有PRO版功能",
        model_4_item_3_feature_2: "每月200至1000万免费字符",
        model_4_item_3_feature_3: "全部AI工具",
        model_4_item_3_feature_4: "单个项目20至500个文件",
        model_4_item_3_feature_5: "大模型翻译智能体",
        model_4_item_3_feature_6: "单文件100MB至500MB",
        model_4_item_3_feature_7: "10人至100人协作",
        model_4_item_3_feature_8: "扫描版PDF/图片格式支持",
        model_4_item_3_feature_9: "多语言本地化项目管理",
        model_4_item_3_feature_10: "专属技术支持工作群",
        model_4_item_3_btn: "7天免费体验",
        model_4_item_3_price_1: "￥12000",
        model_4_item_3_price_1_crossed: "￥599",
        model_4_item_3_price_1_expires: "年",
        model_4_item_3_price_2: "￥23800",
        model_4_item_3_price_2_crossed: "￥5999",
        model_4_item_3_price_2_expires: "二年",
        model_4_item_3_price_3: "￥35600",
        model_4_item_3_price_3_crossed: "￥5999",
        model_4_item_3_price_3_expires: "三年",
        //feature_4
        model_4_item_4_title: "教育版",
        model_4_item_4_feature_1: "所有PRO版功能",
        model_4_item_4_feature_2: "每月200万免费字符",
        model_4_item_4_feature_3: "全部AI工具",
        model_4_item_4_feature_4: "大模型翻译智能体",
        model_4_item_4_feature_5: "更大文件",
        model_4_item_4_feature_6: "单个项目更多文件数",
        model_4_item_4_feature_7: "多语言本地化项目管理",
        model_4_item_4_feature_8: "定制学生人数",
        model_4_item_4_feature_9: "专属技术支持工作群",
        model_4_item_4_btn: "联系我们",

        model_4_char_btn_1: "立即购买",
        model_4_char_btn_2: "联系我们",

        model_4_char_1_title: "10万字符",
        model_4_char_1_price: "¥{price}元",
        model_4_char_1_desc: "相当于{price}元/万字符",
        model_4_char_2_title: "50万字符",
        model_4_char_2_price: "¥99元",
        model_4_char_2_desc: "相当于1.99元/万字符",
        model_4_char_3_title: "100万字符",
        model_4_char_3_price: "¥179元",
        model_4_char_3_desc: "相当于1.79元/万字符",
        model_4_char_4_title: "1000万字符",
        model_4_char_4_price: "¥1599元",
        model_4_char_4_desc: "相当于1.59元/万字符", 
        model_4_char_5_title: "一亿以上",    

        model_5_title: "用户评价",
        model_5_experience_1: "{year}年翻译经验",
        model_5_experience_2: "墨尔本大学教师",
        model_5_experience_3: "{year}年翻译项目管理经验",
        model_5_experience_4: "天津外国语大学英语笔译学生",
        model_5_item_1_user: "Bobbie Chen",
        model_5_item_1_desc: "用户编辑界面简洁容易操作，还提供多个翻译模型，能根据用户需求进行对比、选择，而不用在多个模型之间来回切换，节省了不少时间。综合考虑，LanguageX是市面上不可多得、新手小白友好的翻译辅助软件。",
        model_5_item_2_user: "老叮当",
        model_5_item_2_desc: "一款针对专业级翻译打造的翻译工具。莫兰迪的配色，恰到好处的动画，防呆的操作逻辑，让每天的翻译工作都变得更加便捷、愉快。我一直觉得未来的翻译工具除了功能强大，也要有温度，可成长，常用常新，现在它出现了——LanguageX！",
        model_5_item_3_user: "Flora Wang",
        model_5_item_3_desc: "我非常认同LanguageX“机器的工作归机器，人的工作归人”的理念。它更像是一位“知音搭档”，不仅能预处理机械重复的基础翻译，还能为译者提供应对复杂翻译任务的思路灵感，激发译者产出超越机器的高质量译文。它提供的“主流翻译模型对比”“语料对齐”“AI润色”等众多功能让我眼前一亮。如果你还没找到一款“即刻上手、相见恨晚”的翻译工具，我推荐你试试“LanguageX”。",
        model_5_item_4_user: "胡可",
        model_5_item_4_desc: "对年轻译者、入门翻译技术的学生而言，LanguageX有三个独特的优势。第一，界面友好：LanguageX的界面交互清晰直观，降低了上手难度和学习成本；第二，功能全面：除记忆库与术语库外，机械模型结果对比等功能，可有效帮助用户提升工作效率。第三，适配度高：作为基于云端的平台，LanguageX摆脱了传统CAT工具对操作系统与设备的限制，更贴合年轻用户的使用场景与习惯。",
        model_5_item_5_user: "Sherry",
        model_5_item_5_desc: "系统界面一目了然，颜色清新、易于操作。实现了线上项目分配、校对、QA等流程，接入了各大外部模型以及搜索功能，只需要一个链接即可实现随时随地办公。",
        model_5_item_6_user: "Vicky",
        model_5_item_6_desc: "LanguageX 模型众多，还可以在不同模型之间进行对比，使我们可以更好的精准管理各类型各领域的项目。工具齐全，项目全过程都有能用到的工具，翻译与科技结合，成为一站式项目翻译智能平台。",
        model_5_item_7_user: "徐嘉敏",
        model_5_item_7_desc: "智能匹配精准：基于AI的上下文识别能力出色，专业术语库（TB）和翻译记忆库（TM）的匹配准确率较高，显著减少重复劳动。协作效率高：支持多人实时协作与云端同步，项目进度管理功能完善，适合团队本地化项目。轻量化设计：界面简洁，响应速度快，对硬件配置要求低，长时间使用无卡顿。",

        model_6_title: "加入我们",
        model_6_left_item_1: "我们是一群热爱语言和科技的人",
        model_6_left_item_2: "是语言与科技的“译者”",
        model_6_left_item_3: "是黑客与画家",
        model_6_left_item_4: "一起来构建大模型和语言专家协作新范式",
        model_6_right_item_1: "翻译是一门艺术",
        model_6_right_item_2: "译者是跨语言的作家",
        model_6_right_item_3: "让机器的工作归机器，人的工作归人",

        model_7_title: "我们的客户",

        footer_product: "产品",
        footer_product_1: "AI翻译",
        footer_product_2: "AI辅助翻译",
        footer_product_3: "AI工具箱",
        footer_product_4: "译者社区",
        footer_product_5: "翻译API",
        footer_help: "帮助中心",
        footer_help_1: "LanguageX是什么",
        footer_help_2: "AI辅助翻译指南",
        footer_help_3: "AI工具箱指南",
        footer_help_4: "LanguageX FAQ 常见问题",
        footer_help_5: "TMS企业版指南",
        footer_aboutus: "关于",
        footer_aboutus_1: "联系我们",
        footer_agreement: "用户协议",
        footer_agreement_1: "服务协议",
        footer_agreement_2: "隐私政策",
        footer_contact_1: "公众号",
        footer_contact_2: "用户交流群",
    }
}